import { supportedSystemPositions } from "@/Common/helpers/Positions";
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import actionsList from "@/Constants/actionsList";

const POSITIONS = supportedSystemPositions();

const useAccessPositions = () => {
	const { useAuth } = useAuthorization();
	return {
		[POSITIONS.SALES.SALES_ASSOCIATE]: {
			access: useAuth(actionsList.VIEW_SALES_ASSOCIATE_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SALES_ASSOCIATE_WASHOUTS),
		},
		[POSITIONS.SALES.SALES_MANAGER]: {
			access: useAuth(actionsList.VIEW_SALES_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SALES_MANAGER_WASHOUTS),
		},
		[POSITIONS.SALES.GENERAL_SALES_MANAGER]: {
			access: useAuth(actionsList.VIEW_GENERAL_SALES_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_GENERAL_SALES_MANAGER_WASHOUTS),
		},
		[POSITIONS.FINANCE.FINANCE_MANAGER]: {
			access: useAuth(actionsList.VIEW_FINANCE_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_FINANCE_MANAGER_WASHOUTS),
		},
		[POSITIONS.FINANCE.FINANCE_DIRECTOR]: {
			access: useAuth(actionsList.VIEW_FINANCE_DIRECTOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_FINANCE_DIRECTOR_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_MANAGER_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_FOREMAN_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_FOREMAN_WASHOUTS),
		},
		[POSITIONS.SERVICE.SERVICE_MANAGER]: {
			access: useAuth(actionsList.VIEW_SERVICE_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SERVICE_MANAGER_WASHOUTS),
		},
		[POSITIONS.SERVICE.SERVICE_DIRECTOR]: {
			access: useAuth(actionsList.VIEW_SERVICE_DIRECTOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SERVICE_DIRECTOR_WASHOUTS),
		},
		[POSITIONS.PARTS.PARTS_MANAGER]: {
			access: useAuth(actionsList.VIEW_PARTS_MANAGER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_PARTS_MANAGER_WASHOUTS),
		},
		[POSITIONS.SERVICE.SERVICE_FOREMAN]: {
			access: useAuth(actionsList.VIEW_SERVICE_FOREMAN_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SERVICE_FOREMAN_WASHOUTS),
		},
		[POSITIONS.PARTS.PARTS_DIRECTOR]: {
			access: useAuth(actionsList.VIEW_PARTS_DIRECTOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_PARTS_DIRECTOR_WASHOUTS),
		},
		[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE]: {
			access: useAuth(actionsList.VIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS),
		},
		[POSITIONS.SERVICE.SERVICE_TECHNICIAN]: {
			access: useAuth(actionsList.VIEW_SERVICE_TECHNICIAN_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SERVICE_TECHNICIAN_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_TECHNICIAN_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_TECHNICIAN_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_PAINTER_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_PAINTER_WASHOUTS),
		},
		[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR]: {
			access: useAuth(actionsList.VIEW_BODY_SHOP_ESTIMATOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_BODY_SHOP_ESTIMATOR_WASHOUTS),
		},
		[POSITIONS.SERVICE.SERVICE_ADVISOR]: {
			access: useAuth(actionsList.VIEW_SERVICE_ADVISOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_SERVICE_ADVISOR_WASHOUTS),
		},
		[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR]: {
			access: useAuth(actionsList.VIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS),
			edit: useAuth(actionsList.REVIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS),
		},
	};
};

export default useAccessPositions;
